import { Outlet } from "react-router-dom"
import Header from "../components/Header"

export default function MainLayout() {
  return (
    <div className="min-h-screen p-4 space-y-12 md:px-24 md:py-24 bg-whitesmoke">
      <Header />
      <Outlet />
    </div>
  )
}
